import autoComplete from "@tarekraafat/autocomplete.js";

let searchInput;

document.addEventListener('DOMContentLoaded', function () {
  const searchMobile = document.getElementById('offcanvasMobileMenu');
  const search = document.querySelector('.offcanvas-body button[type=submit]');
  const searchMobileForm = searchMobile.querySelector('.tx-kesearch-pi1 form');
  searchInput = searchMobile.querySelector('.tx-kesearch-pi1 form input');

  if (!searchInput || !search || !searchMobile) {
    console.error("Required DOM elements not found.");
    return;
  }

  search.addEventListener('click', function (event) {
    event.preventDefault();
    search.classList.add('d-none');
    searchMobileForm.classList.remove('d-none')
    searchInput.classList.remove('d-none');
  });

  initializeAutoComplete(searchInput);

  searchMobile.addEventListener('click', function (event) {
    if (!search.contains(event.target) && !searchInput.contains(event.target)) {
      if (search.classList.contains('d-none')) {
        searchInput.classList.add('d-none')
        search.classList.remove('d-none');
      }

    }
  })
});

function initializeAutoComplete(inputElement) {
  const autoCompleteMobileJS = new autoComplete({
    selector: () => inputElement,
    placeHolder: "Suche",
    data: {
      src: async (query) => {
        try {
          const response = await fetch(`/?type=123&tx_kesearch_pi1[sword]=${query}`);
          const resultPage = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(resultPage, "text/html");

          const resultList = doc.querySelector('#kesearch_results');
          return resultList.querySelectorAll('.result-title a');

        } catch (error) {
          console.error("Error fetching search results:", error);
          return [];
        }
      },
    },
    resultsList: {
      element: (list, data) => {
        if (!data.results.length) {
          const message = document.createElement("div");
          message.setAttribute("class", "no_result");
          message.style = "color:black";
          message.innerHTML = `<span>Keine Ergebnisse für "${data.query}" gefunden</span>`;
          list.prepend(message);
        }
      },
      noResults: true,
    },
    resultItem: {
      element: (item, data) => {
        item.innerHTML = `
        <a href="${data.value}">
          ${data.value.innerHTML}
        </a>`;
      },
      highlight: true,
    }
  });
}
